import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface StatusDataFieldInterface extends VarcharDatatypeInterface {
  data?: string;
}

export class StatusDataFieldClass extends String
  implements StatusDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
